module.exports = __webpack_public_path__ + "static/media/soccer-banner.389f931a.webp";